import type BoundsUtil from "../../boundsUtil";
import type MatrixUtil from "../../matrixUtil";
import type { GeomTypeUtil } from "./geomTypeUtil";

/**
 * Geometry functions for point
 */
export default class PT implements GeomTypeUtil {
    private boundsUtil: BoundsUtil;
    private matrixUtil: MatrixUtil;

    constructor(boundsUtil: BoundsUtil, matrixUtil: MatrixUtil) {
        this.boundsUtil = boundsUtil;
        this.matrixUtil = matrixUtil;
    }
    
    /**
     * 
     * @param geom 
     * @param callback 
     * @param owner 
     */
    extractPoints(geom: any[], callback: Function, owner?: any) {
        callback.call(owner, geom, 1);
    }

    /**
     * 
     * @param geom 
     * @param callback 
     * @param owner 
     */
    extractLines(geom: any[], callback: Function, owner?: any) {
        callback.call(owner, [geom[1], geom[2], geom[1], geom[2]], 0, 4);
    }

    /**
     * 
     * @param geom 
     * @param bounds 
     * 
     * @returns 
     */
    getBounds(geom: any[], bounds: number[]): number[] {
        return this.boundsUtil.valueOf(geom, bounds, 1);
    }

    /**
     * 
     * @param geom 
     * @param matrix 
     * 
     * @returns 
     */
    transform(geom: any[], matrix: any[]): any[] {
        return this.matrixUtil.transform(matrix, geom, 1, geom.length, ["PT"]);
    }

    /**
     * 
     * @param geom 
     * @param threshold 
     * 
     * @returns 
     */
    generalize(geom: any[], threshold: number): any[] {
        return geom;
    }
}
